import { Link } from "react-router-dom";
import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";

export default function NotFound() {
  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <Header />
      <main className="flex flex-1 items-center justify-center px-4 py-24 text-center">
        <div className="relative">
          <h1 className="pointer-events-none absolute inset-x-0 -top-16 select-none text-8xl font-black text-background-200 md:-top-24 md:text-[10rem]">
            404
          </h1>
          <div className="relative z-10">
            <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              Page Not Found
            </h2>
            <p className="mt-3 text-foreground-600">
              The page you are looking for does not exist or has been moved.
            </p>
            <p className="mt-2 text-sm text-foreground-500">
              You can return to the homepage or explore our Basetao Spreadsheet guides.
            </p>
            <div className="mt-8 flex flex-col items-center gap-3 sm:flex-row sm:justify-center">
              <Link
                to="/"
                className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-primary-600"
              >
                <i className="ri-home-4-line text-base" aria-hidden="true"></i>
                Back to Homepage
              </Link>
              <Link
                to="/basetao-spreadsheet-guide"
                className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-5 py-2.5 text-sm font-semibold text-foreground-800 transition-colors hover:bg-background-100"
              >
                <i className="ri-file-list-3-line text-base" aria-hidden="true"></i>
                Spreadsheet Guide
              </Link>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}